import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../../store/actions/metaAction";
import server from "../../../api/server";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

const Videos = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);

	const filteredVideos = data?.filter(item =>
		item?.file?.type?.includes("video")
	);

	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);
	const deleteDesign = async slug => {
		try {
			await server(cookie).delete(`/pages/designs/sections/${slug}`);
			toast.success("تم حذف الفيديو بنجاح");
			onStart();
		} catch (error) {
			toast.error("خطاء في حذف الفيديو");
		}
	};

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "جميع فيديوهات التصاميم",
				breadcrumb: "فيديوهات التصاميم",
				button: {
					show: false,
					text: false,
					link: false,
				},
			})
		);
		try {
			const pageData = await server(cookie).get("/pages/designs/sections");

			setData(pageData?.data?.data?.sections);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};
	return (
		<div>
			{loading && <Loader />}

			<Container>
				<div className="card p-3">
					<Row className="g-3">
						{filteredVideos?.length > 0 ? (
							filteredVideos?.map((item, index) => (
								<Col xs={12} md={3} key={index}>
									<div className="design-item">
										<video
											src={item?.fileUrl}
											alt="design-img"
											style={{ width: "100%", height: "100%" }}
										/>
										<Link to={`/designs/show/${item?.slug}`}>
											<i className="fa fa-edit"></i>
										</Link>
										<button
											className="delete-btn"
											onClick={() => {
												deleteDesign(item?.slug);
											}}
										>
											<i className="fa fa-trash"></i>
										</button>
									</div>
								</Col>
							))
						) : (
							<div className="text-center my-5">
								<h4>لا يوجد بيانات لعرضها</h4>
							</div>
						)}
					</Row>
				</div>
			</Container>
		</div>
	);
};

export default Videos;
